import round from 'util/numbers/round';

export default num => {
    const abs = Math.abs(num);
    if (abs < 10) {
        return round(num, abs < 0.1 ? 1000 : 10);
    }
    return Math.round(num);
};
